import React, { Component } from "react";
import PropTypes from "prop-types";
import VideoModalPlayer from "./VideoModalPlayer";
import axios from "axios";
import getContent from "pp-react-l10n";
import getHTMLElement from "../lib/setHtmlHelper";
import MostPopularArticlesHome from "../container/MostPopularArticlesHome.js";
import formatDate from "../lib/dateHelper";

class Resultslistcontainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resultsInfoBundle: this.props.resultsInfo,
      page: 1,
      page_size: 12,
      resultsRefID: this.props.refID,
    };
    this.loadMoreResults = this.loadMoreResults.bind(this);
  }

  loadMoreResults() {
    // trackLink({ id: 'brcCategoryLoadMoreClick', link: this.state.resultsRefID });

    const self = this;
    axios
      .get("/brc/loadMore", {
        params: {
          page: this.state.page,
          page_size: this.state.page_size,
          pageType: "results",
          refID: this.state.resultsRefID,
        },
      })
      .then(function (response) {
        if (response.data.results) {
          self.setState({
            resultsInfoBundle: JSON.parse(response.data.results),
            page_size: self.state.page_size + 3,
          });
        } else {
          self.setState({
            resultsInfoBundle: self.state.resultsInfoBundle,
          });
        }
      })
      .catch(function (error) {
        self.setState({
          resultsInfoBundle: self.state.resultsInfoBundle,
        });
      });
  }

  render() {
    const getListContent = getContent("staticContent");
    const topicsHash = this.props.topicsHash;
    const country = this.props.country.toLowerCase();
    const locale = this.props.locale.split("_")[0];
    const fontChange =
      this.props.country === "vn" && this.props.locale === "vi_VN"
        ? "vnFont"
        : this.props.country === 'jp' && this.props.locale === 'ja_JP' ? 'jpFont' : "";
    if (
      this.state.resultsRefID === "most-popular-articles" &&
      this.props.isPopArticleEnabled
    ) {
      return (
        <div>
          <MostPopularArticlesHome
            popArticlesHomeInfo={this.props.popArticlesHomeInfo}
            country={country}
            locale={locale}
          />
        </div>
      );
    } else {
      if (this.state.resultsInfoBundle.length > 0) {
        return (
          <div id="resultsilist-container" className="resultsContainer">
            <div>
              <div className="resultslistcontainer">
                <ul className="results_list">
                  {this.state.resultsInfoBundle.map((tile, index) => {
                    const updatedDate = formatDate(tile.updated_time, country, locale);
                    const listItemId = `results-list-item-${index}`;
                    return (
                      <li className="results" key={index}>
                        <hr className="article-divider" />
                        <a
                          data-pa-click={`brcCategoryListArticleClick|${tile.url_slug}`}
                          className="arrow resultsBtn"
                          href={`/${country}/brc/article/${tile.url_slug}`}
                        >
                          <span className="visuallyhidden">{tile.heading}</span>
                        </a>
                        <div className="results-image">
                          {!tile.sm_bg ? (
                            <span />
                          ) : (
                            <div
                              className="set-image"
                              style={{
                                backgroundImage: `url(${tile.sm_bg})`,
                              }}
                            >
                              <VideoModalPlayer
                                source={tile.content}
                                id={listItemId}
                              />
                            </div>
                          )}
                        </div>
                        <div className="results-content">
                          <h2
                            className="vx_text-5 results_cat"
                            key={tile.category + index}
                          >
                            {(topicsHash[tile.category] || tile.category) &&
                              (
                                topicsHash[tile.category] || tile.category
                              ).toUpperCase()}{" "}
                          </h2>
                          <h2 className={`results_heading ${fontChange}`}>
                            <a
                              className={`results_heading ${fontChange}`}
                              data-pa-click={`brcCategoryListArticleClick|${tile.url_slug}`}
                              href={
                                this.props.attachUrl.length > 0
                                  ? `/${country}/brc/article/${tile.url_slug}?${this.props.attachUrl}`
                                  : `/${country}/brc/article/${tile.url_slug}`
                              }
                              key={tile.heading + index}
                            >
                              {" "}
                              {getHTMLElement(tile.heading, { useHTML: true })}
                            </a>
                          </h2>
                          <div
                            className="vx_text-body_secondary results_date"
                            key={updatedDate + index}
                          >
                            {updatedDate === "Invalid date" ? "" : updatedDate}
                          </div>
                          <div
                            className="vx_text-body results_description"
                            key={tile.desc + index}
                          >
                            {" "}
                            {getHTMLElement(tile.desc, { useHTML: true })}{" "}
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <br />
              {this.state.resultsInfoBundle.length <
                this.props.totalResultsList ? (
                <div className="category-btn">
                  <hr className="content-seperator" />
                  <button
                    data-pa-click={`brcCategoryLoadMoreClick|${this.state.resultsRefID}`}
                    className="load-more-btn"
                    onClick={this.loadMoreResults}
                  >
                    {getListContent("brc.tilesButton")}
                  </button>
                </div>
              ) : (
                <span />
              )}
            </div>
          </div>
        );
      } else {
        return (
          <div className="noArticlesFound">
            <h2> {getListContent("brc.noArticlesFound")}</h2>
          </div>
        );
      }
    }
  }
}

export default Resultslistcontainer;

Resultslistcontainer.propTypes = {
  resultsInfo: PropTypes.array,
  totalResultsList: PropTypes.number,
  refID: PropTypes.string,
  topicsHash: PropTypes.object,
  country: PropTypes.string,
};
